/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ScaniaReadMoreTextNode } from './ScaniaReadMoreTextNode'
import {
  ScaniaReadMoreTextNodeFromJSON,
  ScaniaReadMoreTextNodeFromJSONTyped,
  ScaniaReadMoreTextNodeToJSON,
} from './ScaniaReadMoreTextNode'

/**
 *
 * @export
 * @interface GuidedViewMenuLeafNode
 */
export interface GuidedViewMenuLeafNode {
  /**
   *
   * @type {string}
   * @memberof GuidedViewMenuLeafNode
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof GuidedViewMenuLeafNode
   */
  hasreadMore: boolean
  /**
   *
   * @type {Array<ScaniaReadMoreTextNode>}
   * @memberof GuidedViewMenuLeafNode
   */
  readmoreText?: Array<ScaniaReadMoreTextNode> | null
  /**
   *
   * @type {string}
   * @memberof GuidedViewMenuLeafNode
   */
  iconUrl?: string | null
  /**
   *
   * @type {string}
   * @memberof GuidedViewMenuLeafNode
   */
  shortText?: string | null
  /**
   *
   * @type {boolean}
   * @memberof GuidedViewMenuLeafNode
   */
  isSelected: boolean
  /**
   *
   * @type {boolean}
   * @memberof GuidedViewMenuLeafNode
   */
  isColorMenu: boolean
}

/**
 * Check if a given object implements the GuidedViewMenuLeafNode interface.
 */
export function instanceOfGuidedViewMenuLeafNode(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'hasreadMore' in value
  isInstance = isInstance && 'isSelected' in value
  isInstance = isInstance && 'isColorMenu' in value

  return isInstance
}

export function GuidedViewMenuLeafNodeFromJSON(
  json: any,
): GuidedViewMenuLeafNode {
  return GuidedViewMenuLeafNodeFromJSONTyped(json, false)
}

export function GuidedViewMenuLeafNodeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GuidedViewMenuLeafNode {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    hasreadMore: json['hasreadMore'],
    readmoreText: !exists(json, 'readmoreText')
      ? undefined
      : json['readmoreText'] === null
      ? null
      : (json['readmoreText'] as Array<any>).map(
          ScaniaReadMoreTextNodeFromJSON,
        ),
    iconUrl: !exists(json, 'iconUrl') ? undefined : json['iconUrl'],
    shortText: !exists(json, 'shortText') ? undefined : json['shortText'],
    isSelected: json['isSelected'],
    isColorMenu: json['isColorMenu'],
  }
}

export function GuidedViewMenuLeafNodeToJSON(
  value?: GuidedViewMenuLeafNode | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    hasreadMore: value.hasreadMore,
    readmoreText:
      value.readmoreText === undefined
        ? undefined
        : value.readmoreText === null
        ? null
        : (value.readmoreText as Array<any>).map(ScaniaReadMoreTextNodeToJSON),
    iconUrl: value.iconUrl,
    shortText: value.shortText,
    isSelected: value.isSelected,
    isColorMenu: value.isColorMenu,
  }
}
